import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";

function Ourpolicies() {
  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />
        <div className="row py-5 px-sm-5">
          <div className="col">
            <h1 className="text-center fw-bold">Terms & Conditions</h1>
            <p className="mt-3">
            Privacy Policy ("Agreement") are entered into by and
              between Regasthani AAchar ("Company") and you ("Customer").
            </p>
            <ul className="mt-4">
              <li>
                <h5 className="fw-bold">1. Acceptance Of Terms</h5>
                <p>
                  By accessing this website or purchasing
                  products from Regasthani AAchar, you agree to be bound by
                  these terms and conditions. If you do not agree with any of
                  these terms, you must not use the website or make a purchase.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">2. Products</h5>
                <p>
                Regasthani AAchar offers dairy products, including A2 desi
                  cow ghee, buffalo ghee, honey, and mustard oil ("Products").
                  The Company strives to provide accurate descriptions and
                  images, but does not guarantee that the information is
                  complete, reliable, current, or error-free.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">3. Orders And Payment</h5>
                <p>
                  (a) <strong>Orders:</strong> All orders are subject to
                  acceptance by Regasthani AAchar. The Company reserves the
                  right to refuse or cancel any order at any time.
                </p>
                <p>
                  (b) <strong>Pricing:</strong> Prices for Products are listed
                  on the website and are subject to change without notice. The
                  Customer is responsible for any applicable taxes, duties, or
                  customs fees.
                </p>
                <p>
                  (c) <strong>Payment:</strong> Payment must be made at the time
                  of purchase. Regasthani AAchar accepts various payment
                  methods as indicated on the website.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}

export default Ourpolicies;
